
export enum AssetTachograph {
  Absent= 'Absent',
  Digital= 'Digital',
  Analog= 'Analog',

}